const addNotification = (userObj) => {
    return {
        type: "ADD_NOTIFICATION",
        payload: userObj
    }
}

export default {
    addNotification
}